require('./okDiscountModal.scss');
const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const OKModal = require('components/commons/OKModal/OKModal');
const { OKLink } = require('commonsComponents/OKLink');
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { getOriginCountry } = require('utilities/countryHelper');

// @constants
const EMAIL_ERROR_LIST = ['410002', '410017'];

class OkDiscountModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleRedirectPublicDiscountLink = this.handleRedirectPublicDiscountLink.bind(this);
    }

    handleGoBack() {
        this.props.history.goBack();
    }

    hasKnownError(errorList, errorField) {
        const { immErrorList } = this.props;
        return immErrorList.some(errorData => errorList.includes(errorData.get('code')) && errorData.get('field') === errorField)
    }

    handleRedirectPublicDiscountLink() {
        const { promotionCategoryPath, immGlobalVariables, immProfile } = this.props;
        const country = getOriginCountry(immProfile.get('originCountry'));
        const publicSiteUrl = getPublicSiteUrl(country);
        const publicDiscountPath = immGlobalVariables.getIn(['variables', 'parameters', 'public_urls', 'discounts']);
        const publicDiscountLink = `${publicSiteUrl}${publicDiscountPath}/${promotionCategoryPath}`;
        location.href = publicDiscountLink;
    }

    render() {
        const {
            immGlobalVariables,
            onRegister,
            error,
            inProgress,
            isOpen,
        } = this.props;

        let actionButtonText;
        let titleModal;
        const hasEmailError = this.hasKnownError(EMAIL_ERROR_LIST, 'userEmail');

        if (error) {
            const modalHeader = (
                <i className="ok-discount-modal__icon-error-icon icon-error" />
            );
            let valueText;

            if (hasEmailError) {
                valueText = formatText('OKDiscounts-errorEmailText', [immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente'])]);
                titleModal = 'OKDiscounts-errorEmailTitle';
            } else {
                actionButtonText = 'OKDiscounts-retry';
                valueText = formatText('OKDiscounts-errorText', [immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente'])]);
                titleModal = 'OKDiscounts-errorTitle';
            }

            return (
                <OKModal
                    description={valueText}
                    headerAlignment="left"
                    headerContent={modalHeader}
                    headerType="custom"
                    isOpen={isOpen}
                    footerType="navigation"
                    onCloseCallback={this.handleRedirectPublicDiscountLink}
                    onPrimaryButtonClick={onRegister}
                    onPrimaryButtonLoading={inProgress}
                    onSecondaryButtonClick={this.handleRedirectPublicDiscountLink}
                    primaryButtonText={actionButtonText}
                    secondaryButtonText="OKDiscounts-backToOKDiscountsPlan"
                    shouldCloseOnOverlayClick={false}
                    title={titleModal}
                />
            );
        } else {
            actionButtonText = 'OKDiscounts-register';
            titleModal = 'OKDiscounts-title';
            const titlesSection = (
                <div className="ok-discount-modal__titles-section">
                    <FormattedText value="OKDiscounts-subtitle" className="ok-discount-modal__subtitle" />
                    <OKLink
                        modifier="emphasize"
                        to={formatText('OKDiscounts-linkUrl')}
                        target="_blank"
                    >
                        <FormattedText
                            value="OKDiscounts-termsAndConditionsLinkText"
                            className="ok-discount-modal__termsandconditionslink"
                        />
                    </OKLink>
                </div>
            );

            return (
                <OKModal
                    content={titlesSection}
                    isOpen={isOpen}
                    footerType="navigation"
                    onCloseCallback={this.handleRedirectPublicDiscountLink}
                    onPrimaryButtonClick={onRegister}
                    onPrimaryButtonLoading={inProgress}
                    onSecondaryButtonClick={this.handleRedirectPublicDiscountLink}
                    primaryButtonText={actionButtonText}
                    secondaryButtonText="OKDiscounts-backToOKDiscountsPlan"
                    shouldCloseOnOverlayClick={false}
                    title={titleModal}
                />
            );
        }

    }
}
OkDiscountModal.defaultProps = {
    inProgress: false,
    submitSuccessful: false,
    error: false,
    isOpen: false,
    promotionCategoryPath: ''
}

OkDiscountModal.propTypes = {
    history: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    inProgress: PropTypes.bool.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onRegister: PropTypes.func.isRequired,
    error: PropTypes.bool.isRequired,
    immErrorList: PropTypes.object,
    submitSuccessful: PropTypes.bool.isRequired,
    promotionCategoryPath: PropTypes.string
}

module.exports = withRouter(OkDiscountModal);
